import React from "react";

const RealEstateSkelton = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 animate-pulse">
      {/* Column 1: Value & Acquisition Price */}
      <div className="space-y-3">
        <div className="flex items-baseline justify-between gap-16 w-fit">
          <div className="h-4 w-16 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-24 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="space-y-1">
          <div className="flex justify-between items-baseline gap-4 w-fit">
            <div className="h-4 w-28 bg-gray-300 dark:bg-gray-700 rounded"></div>
            <div className="h-6 w-24 bg-gray-300 dark:bg-gray-700 rounded"></div>
          </div>
        </div>
      </div>

      {/* Column 2: Gain & ROI */}
      <div className="space-y-3">
        <div className="flex items-baseline justify-between gap-8 w-fit">
          <div className="h-4 w-10 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex items-baseline justify-between gap-8 w-fit">
          <div className="h-4 w-10 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>

      {/* Column 3: Realised & Unrealised */}
      <div className="space-y-3">
        <div className="flex justify-between items-baseline gap-12 w-fit">
          <div className="h-4 w-28 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex justify-between items-baseline gap-8 w-fit">
          <div className="h-4 w-32 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>

      {/* Column 4: Income & Expense */}
      <div className="space-y-3">
        <div className="flex justify-between items-baseline gap-8 w-fit">
          <div className="h-4 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex justify-between items-baseline gap-8 w-fit">
          <div className="h-4 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>
    </div>
  );
};

export default RealEstateSkelton;
